import React from 'react';
import { useParams } from 'react-router-dom';

import PDP from 'components/consumer/PDP';
import useModularPDPState from 'data-hooks/useModularPDPState';

const ModularComp = () => {
  const { slug = null } = useParams();
  useModularPDPState(null, slug, {
    skipQuery: false,
  });

  return <PDP key={slug} pdpIsModularBYOProduct />;
};

export default ModularComp;
